import {SERVER_GG_STORE_REPLY} from '../../constans/index';
import {
    GAME_UPDATE_REQUEST,
    GAME_UPDATE_SUCCESS,
    GAME_UPDATE_FAILURE,
} from '../../types/index';
import {RSAA} from 'redux-api-middleware';
import headers from "../../utils/headers";

const UpdateGameAction = (id,data_target) => ({

    [RSAA]: {
        endpoint: `${SERVER_GG_STORE_REPLY}/api/games/${id}`,
        method: 'PUT',
        headers: (headers()),
        body: (() => {
            return JSON.stringify(data_target);
        }),
        types: [
            GAME_UPDATE_REQUEST,
            {
                type: GAME_UPDATE_SUCCESS,
                payload: async (action, state, res) => {
                    const contentType = res.headers.get('Content-Type');
                    let data = [];
                    if (contentType && ~contentType.indexOf('json')) {
                        await res.json().then((json) => {
                            data = json.data
                        });
                        return {
                            "code": 0,
                            "type": GAME_UPDATE_SUCCESS,
                            "data": data
                        }
                    }

                }
            },
            {
                type: GAME_UPDATE_FAILURE,
                payload: async (action, state, res) => {

                    let message = "";
                    await res.json().then((json) => {
                        message = json.message;
                    });

                    return {
                        "code": 1,
                        "type": GAME_UPDATE_FAILURE,
                        "message": message,
                        "data": [],
                    }
                }
            }
        ]
    }

});

export {UpdateGameAction}